var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70417 13.6486L12.0604 17.5H12.276L20.6875 0.5L9.70417 13.6486ZM15.2948 0.852278L9.27083 12.7013H9.11771L7.48333 10.2051L15.2948 0.852278ZM10.4552 1.71456L6.8875 8.70344H6.8L5.81875 7.26789L10.4552 1.71456ZM4.74896 6.1865C4.74896 6.1865 3.51875 16.2174 3.78646 16.5017C3.94304 16.7087 4.15786 16.8739 4.40862 16.9802C4.65938 17.0864 4.93694 17.13 5.2125 17.1062H5.92708V17.5H0V17.1052H0.439582C0.793068 17.1361 1.14948 17.0869 1.47677 16.9619C1.80406 16.8369 2.09196 16.6402 2.31458 16.3893C2.53333 16.0956 3.96563 4.67822 3.96563 4.67822L4.74896 6.1865ZM20.3927 4.28722C20.3927 4.28722 22.1292 16.2288 22.4052 16.5149C22.6623 16.7214 22.9624 16.8789 23.2879 16.9782C23.6134 17.0775 23.9576 17.1165 24.3 17.0929H25V17.5H16.4062V17.0929H17.1208C17.5081 17.1099 17.8944 17.0461 18.2502 16.9064C18.6059 16.7668 18.9216 16.555 19.1729 16.2873C19.3917 15.9936 18.1906 8.56178 18.1906 8.56178L20.3927 4.28722Z",
    fill: "#707079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakor);
export default __webpack_public_path__ + "static/media/makor.b59156f808273fd770cd3d0cb8bb9aad.svg";
export { ForwardRef as ReactComponent };